module.exports = __webpack_public_path__ + "img/mainLogo.e064fbd8.png";